<script setup lang="ts">
import { ref } from "vue"
import {
  NNotificationProvider,
  NMessageProvider,
  NLoadingBarProvider,
  NDialogProvider,
  NGlobalStyle,
  NSpin,
  NInfiniteScroll,
} from "naive-ui"
import { useAuth } from "@/composables/auth/useAuth"
import ConnectivityToastMount from "@/components/global/ConnectivityToastMount.vue"
import AppHeader from "./components/global/AppHeader.vue"
import { useOnlineStatus } from "@/composables/global/useOnlineStatus"
import OfflineBar from "./components/global/OfflineBar.vue"
import MainMenuDrawer from "@/components/global/MainMenuDrawer.vue"

const { user, loading } = useAuth()
const { online } = useOnlineStatus()

const showMenu = ref(false)
</script>

<template>
  <div class="app-shell">
    <n-global-style />
    <n-loading-bar-provider>
      <NDialogProvider>
        <NMessageProvider placement="top" container-style="top: 70px;">
          <transition>
            <OfflineBar v-if="!online && user" />
          </transition>
          <ConnectivityToastMount />
          <n-notification-provider>
            <MainMenuDrawer :show="showMenu" @close="showMenu = false" />
            <AppHeader @menu="showMenu = !showMenu" />
            <div
              v-if="loading"
              style="display: grid; place-items: center; height: 100vh">
              <n-spin size="large" />
            </div>
            <div class="app-main" v-else>
              <n-infinite-scroll>
                <RouterView v-slot="{ Component }">
                  <component :is="Component" />
                </RouterView>
              </n-infinite-scroll>
            </div>
          </n-notification-provider>
        </NMessageProvider>
      </NDialogProvider>
    </n-loading-bar-provider>
  </div>
</template>
